<template>
  <div
    v-bind:class="{ label: true, 'label--demo': env === 'demo' }"
    @click="onClick"
  >
    {{ env }}
  </div>
</template>

<script>
export default {
  props: {
    onClick: Function,
    env: String
  }
};
</script>

<style scoped>
.label {
  position: absolute;
  top: 64px;
  left: 0;
  transform: rotate(-90deg);
  transform-origin: top left;
  font-size: 9px;
  text-transform: uppercase;
  letter-spacing: 0.06px;
  font-weight: 600;
  width: 64px;
  height: 20px;
  background-color: #eb5757;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: default;
}
.label--demo {
  transition: opacity 0.3s;
  cursor: pointer;
  background-color: #0821ff;
}
.label--demo:hover {
  opacity: 0.75;
}

@media (max-width: 600px) {
  .label {
    top: 56px;
    width: 56px;
  }
}
</style>
